import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './Components/home/home.component';
import { ExamplesComponent } from './Components/examples/examples.component';
import { FeaturesComponent } from './Components/features/features.component';
import { ConsistencyChecksComponent } from './Components/features/consistency-checks/consistency-checks.component';
import { PersonalDictionaryComponent } from './Components/features/personal-dictionary/personal-dictionary.component';
import { CreditsComponent } from './Components/features/credits/credits.component';
import { PricingComponent } from './Components/pricing/pricing.component';
import { EnterpriseComponent } from './Components/enterprise/enterprise.component';
import { LifeSciencesMedicineAndPharmaComponent } from './Components/enterprise/life-sciences-medicine-and-pharma/life-sciences-medicine-and-pharma.component';
import { LanguageServicesPublishingAndMediaComponent } from './Components/enterprise/language-services-publishing-and-media/language-services-publishing-and-media.component';
import { AcademicInstitutionsComponent } from './Components/enterprise/academic-institutions/academic-institutions.component';
import { K12AndElearningComponent } from './Components/enterprise/k12-and-elearning/k12-and-elearning.component';
import { TechnologyPlatformsComponent } from './Components/enterprise/technology-platforms/technology-platforms.component';
import { wordpluginComponent } from './Components/word-plugin/word-plugin.component';
import { TrinkaCloudComponent } from './Components/trinka-cloud/trinka-cloud.component';
import { AboutUsComponent } from './Components/about-us/about-us.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { WorkWithUsComponent } from './Components/work-with-us/work-with-us.component';
import { PrivacyPolicyComponent } from './Components/privacy-policy/privacy-policy.component';
import { TermServicesComponent } from './Components/term-services/term-services.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { GcEditorComponent } from './Components/gc-editor/gc-editor.component';
import { BrowserPluginComponent } from './Components/browser-plugin/browser-plugin.component';
import { AutoEditComponent } from './Components/auto-edit/auto-edit.component';
import { WhitePaperComponent } from './Components/white-paper/white-paper.component';
import { PublicationChecksComponent } from './Components/publication-checks/publication-checks.component';
import { AffiliatesComponent } from './Components/affiliates/affiliates.component';
import { TryADemoComponent } from './Components/try-ademo/try-ademo.component';
import { FAQComponent } from './Components/faq/faq.component';
import { ProfessionalEditingServiceComponent } from './Components/professional-editing-service/professional-editing-service.component';

import { TrinkaVsGrammarlyComponent } from './Components/trinka-vs-grammarly/trinka-vs-grammarly.component';
import { TrinkaVsGingerComponent } from './Components/trinka-vs-ginger/trinka-vs-ginger.component';
import { TrinkaVsLanguagetoolComponent } from './Components/trinka-vs-languagetool/trinka-vs-languagetool.component';
import { TrinkaVsWritefullComponent } from './Components/trinka-vs-writefull/trinka-vs-writefull.component';
import { PowerModeEditingComponent } from './Components/power-mode-editing/power-mode-editing.component';
import { PlagiarismCheckerComponent } from './Components/features/plagiarism-checker/plagiarism-checker.component';
import { APIComponent } from './Components/enterprise/api/api.component';
import { PunctuationCheckerComponent } from './Components/punctuation-checker/punctuation-checker.component';
import { SpellCheckerComponent } from './Components/spell-checker/spell-checker.component';
import { SentenceCheckerComponent } from './Components/sentence-checker/sentence-checker.component';
import { CitationCheckerComponent } from './Components/features/citation-checker/citation-checker.component';
import { CitationSampleReportComponent } from './Components/features/citation-checker/citation-sample-report/citation-sample-report.component';
import { MacwordpluginComponent } from './Components/macwordplugin/macwordplugin.component';
import { LatexGrammarCheckerComponent } from './Components/features/latex-grammar-checker/latex-grammar-checker.component';
import { ParapharsingToolComponent } from './Components/parapharsing-tool/parapharsing-tool.component';
import { AiDetectorToolComponent } from './Components/ai-detector-tool/ai-detector-tool.component';
import { OnlineParaphraserComponent } from './Components/features/online-paraphraser/online-paraphraser.component';
import { DataSensitivePlanComponent } from './Components/enterprise/data-sensitive-plan/data-sensitive-plan.component';
import { GrammarCheckerFeaturesComponent } from './Components/features/grammar-checker-features/grammar-checker-features.component';
import { InclusiveLanguageReportComponent } from './Components/features/inclusive-language-report/inclusive-language-report.component';
import { LegalWritingComponent } from './Components/features/legal-writing/legal-writing.component';
import { OfficialInvoiceComponent } from './Components/official-invoice/official-invoice.component';
import { ProofreadingToolComponent } from './Components/proofreading-tool/proofreading-tool.component';
import { CaseStudyComponent } from './Components/case-study/case-study.component';
import { NitComponent } from './Components/case-study/nit/nit.component';
import { GrammarCheckerToolComponent } from './grammar-checker-tool/grammar-checker-tool.component';
import { PostEventContactFromComponent } from './Components/post-event-contact-from/post-event-contact-from.component';
import { DocumarkComponent } from './Components/features/documark/documark.component';
import { AcademicPhrasebankComponent } from './Components/academic-phrasebank/academic-phrasebank.component';
import { AcademicPhrasebankBrowseComponent } from './Components/academic-phrasebank-browse/academic-phrasebank-browse.component';
import { TNQComponent } from './Components/case-study/tnq/tnq.component';
import { AskTrinkaComponent } from './Components/features/ai-studio/ask-trinka/ask-trinka.component';
import { EnterpriseFormPageComponent } from './Components/enterprise-form-page/enterprise-form-page.component';
import { TranslationComponent } from './Components/features/translation/translation.component';
import { AIAppsLibraryComponent } from './Components/features/ai-studio/aiapps-library/aiapps-library.component';
import { CertificateOfEditingComponent } from './Components/features/certificate-of-editing/certificate-of-editing.component';
const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "features",
    component: FeaturesComponent,
  },
  { path: "features/consistency-check", component: ConsistencyChecksComponent },
  { path: "features/personal-dictionary", component: PersonalDictionaryComponent },
  {
    path: "features/technical-checks",
    redirectTo: "features/publication-readiness-checks",
    pathMatch: "full"
  },
  { path: "features/publication-readiness-checks", component: PublicationChecksComponent },
  {
    path: "features/proofread-file",
    redirectTo: "features/auto-file-edit",
    pathMatch: "full"
  },
  {
    path: "features/auto-file-edit",
    component: AutoEditComponent
  },
  { path: "features/grammar-checker", component: GrammarCheckerFeaturesComponent },
  { path: "features/inclusive-language-check", component: InclusiveLanguageReportComponent },
  { path: "features/legal-writing", component: LegalWritingComponent },
  { path: "features/documark", component: DocumarkComponent },
  { path: "features/ai-studio/ai-assisted-writing", component: AskTrinkaComponent },  
  {
    path: "examples",
    component: ExamplesComponent,
  },
  {
    path: "pricing",
    component: PricingComponent,
  },
  {
    path: "enterprise",
    component: EnterpriseComponent,
  },
  {
    path: "wordplugin",
    component: wordpluginComponent,
  },
  {
    path: "trinkacloud",
    component: TrinkaCloudComponent,
  },
  {
    path: "aboutus",
    component: AboutUsComponent,
  },
  {
    path: "contactus",
    component: ContactUsComponent,
  },
  {
    path: "workwithus",
    component: WorkWithUsComponent,
  },
  {
    path: "privacypolicy",
    component: PrivacyPolicyComponent,
  },
  {
    path: "termsofservices",
    component: TermServicesComponent,
  },
  {
    path: "browser-plugin",
    component: BrowserPluginComponent,
  },
  // {
  //   path: "auto-edit",
  //   component: AutoEditComponent,
  // },

  {
    path: "trinka-vs-grammarly-vs-language-tool",
    component: WhitePaperComponent,
  },
  // {
  //   path: "try-a-demo",
  //   component: GcEditorComponent,
  // },
  {
    path: "try-a-demo",
    component: TryADemoComponent,
  },
  // {
  //   path: "publication-check",
  //   component: PublicationChecksComponent,
  // },
  {
    path: "affiliates",
    component: AffiliatesComponent,
  },
  {
    path: "professional-editing-service",
    component: ProfessionalEditingServiceComponent,
  },
  {
    path: "faqs",
    component: FAQComponent,
  },
  { path: "trinka-vs-grammarly", component: TrinkaVsGrammarlyComponent },
  { path: "trinka-vs-ginger", component: TrinkaVsGingerComponent },
  { path: "trinka-vs-languagetool", component: TrinkaVsLanguagetoolComponent },
  { path: "trinka-vs-writefull", component: TrinkaVsWritefullComponent },
  { path: "grammar-checker", component: GcEditorComponent },
  { path: "enterprise", component: EnterpriseComponent },
  { path: "enterprise/life-sciences-medicine-and-pharma", component: LifeSciencesMedicineAndPharmaComponent },
  { path: "enterprise/language-services-publishing-and-media", component: LanguageServicesPublishingAndMediaComponent },
  { path: "enterprise/academic-institutions", component: AcademicInstitutionsComponent },
  { path: "enterprise/k12-and-elearning", component: K12AndElearningComponent },
  { path: "enterprise/technology-platforms", component: TechnologyPlatformsComponent },
  { path: "enterprise/inquiry", component: EnterpriseFormPageComponent},
  { path: "features/credits", component: CreditsComponent },
  { path: "features/plagiarism-check", component: PlagiarismCheckerComponent },
  { path: "features/translation", component: TranslationComponent },
  { path: "features/ai-studio/ai-writing-tools", component: AIAppsLibraryComponent },
  { path: "features/certificate-of-editing", component: CertificateOfEditingComponent },
  { path: "enterprise/grammar-checker-api", component: APIComponent },
  { path: "punctuation-checker", component: PunctuationCheckerComponent },
  { path: "spell-checker", component: SpellCheckerComponent },
  { path: "sentence-checker", component: SentenceCheckerComponent },
  { path: "features/citation-checker", component: CitationCheckerComponent },
  { path: "citation-checker/sample-report", component: CitationSampleReportComponent },
  { path: "ms-word-addin-for-mac", component: MacwordpluginComponent },
  { path: "features/latex-grammar-checker", component: LatexGrammarCheckerComponent },
  { path: "paraphrasing-tool", component: ParapharsingToolComponent },
  { path: "ai-content-detector", component: AiDetectorToolComponent },
  { path: "features/paraphraser", component: OnlineParaphraserComponent },
  { path: "enterprise/confidential-data-plan-for-grammar-checker", component: DataSensitivePlanComponent },
  { path: "local-invoice", component: OfficialInvoiceComponent },
  { path: "english-proofreading-tool", component: ProofreadingToolComponent },
  { path: 'case-study', component: CaseStudyComponent },
  { path: 'case-study/nit', component: NitComponent },
  { path: 'case-study/tnq', component: TNQComponent },
  { path: 'grammar-checker-tool', component: GrammarCheckerToolComponent },
  { path: 'post-event-contact-form', component: PostEventContactFromComponent },
  { path: "academic-phrasebank", component: AcademicPhrasebankComponent },
  { path: "academic-phrasebank-browse/:topic/:subtopic", component: AcademicPhrasebankBrowseComponent },
  { path: "videos", loadChildren: () => import('./modules/videos/videos.module').then(m => m.VideosModule)},
  { path: "news",  loadChildren: () => import('./modules/news/news.module').then(m => m.NewsModule)},
  {
    path: 'brand-list',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
